import React, { useEffect, useState } from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './CalendarDetail.scss';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import CalendarDetailToolbar from './CalendarDetailToolbar/CalendarDetailToolbar';
import { getProjectsCalendarIndicator } from '../../../redux/actions/indicatorProjects';
import Indicator from '../../../models/Indicator';
import { useDispatch, useSelector } from 'react-redux';
import CustomEvent from '../../ProjectDetail/Calendar/CustomCalendar/CustomEvent/CustomEvent';
import { parseEventsForCalendar } from '../../ProjectDetail/Calendar/Calendar';
import CalendarFilters from '../../ProjectDetail/Calendar/CalendarFilters/CalendarFilters';
import { SearchRender } from '../../Util/CustomInput/SearchRender/SearchRender';
import { useTranslation } from 'react-i18next';
import { EventType } from '../../../models/EventType';
import { setCalendarEvents } from '../../../redux/actions/calendar';
import FilterIndicators from '../../../models/FilterIndicators';
import { AppMenuTabs } from '../../MenuTabs/userTabsInterface';
import { setIndicatorResponse, setLoading } from '../../../redux/actions/dataTable';
import { getNewFilteredIndicators } from '../../../api/indicatorApi';
import { translateMultipleText } from '../../../services/stringUtil';
import { emptyProjects } from '../../Portfolio/PortfolioUtil';
import { ProjectProductTypes } from '../../../models/ProjectProductTypes';
import { processIndicators } from '../../Portfolio/indicatorHelper';
import { arrayMove } from 'react-sortable-hoc';
import { addIndicators } from '../../../redux/actions/indicators';
import { setCurrentIndicator } from '../../../redux/actions/currentIndicator';
import { updateCreatingOrEditing } from '../../../redux/actions/menuTabs';
import Filter from '../../Portfolio/Filter/Filter';

type Props = {
  currentIndicator: Indicator;
  indicatorKey: string;
};
const localizer = momentLocalizer(moment);
export const CalendarDetail = ({ currentIndicator, indicatorKey }: Props) => {
  //This component includes validations to not display inactive CT's and Disbursements.

  const calendar = useSelector<any, any>(state => state.calendar);
  const user = useSelector<any, any>(state => state.user);
  const { filters, events } = calendar;
  const dispatch = useDispatch();
  const [eventOfMonthState, setEventOfMonthState] = useState<any[]>([]);
  const [searchTermState, setSearchTermState] = useState('');

  const { t } = useTranslation();

  // Filter
  const filterIndicators = useSelector<any, FilterIndicators>(state => state.filterIndicators);
  const stateProjectProductTypes = useSelector<any, FilterIndicators>(
    state => state.indicatorPayload.payload.projectProductTypes,
  );
  const menuTabs = useSelector<any, AppMenuTabs>(state => state.menuTabs);
  const portfolioSelectedTab = menuTabs.portfolioSelectedTab;
  const creatingOrEditing = menuTabs.creatingOrEditing;
  const [isLoading, setIsLoading] = React.useState(false);
  const [totalProjects, setTotalProjects] = React.useState(false);
  const [flag, setFlag] = useState<boolean>(false);

  const projectTypeFilterChange = {
    ...filterIndicators,
    common: { ...filterIndicators.common, projectTypeFilters: stateProjectProductTypes },
    projectTypeFilters: stateProjectProductTypes,
  };
  const handleCommonFilterChange = async () => {
    dispatch(setLoading(true));
    setIsLoading(true);

    try {
      const indicatorsToProcess = await getNewFilteredIndicators(
        {},
        { projectProductTypes: stateProjectProductTypes },
        {
          ...projectTypeFilterChange.common,
        },
      );
      dispatch(setIndicatorResponse(indicatorsToProcess));
      startProcessIndicators(
        indicatorsToProcess,
        translateMultipleText(` ${' '} ${portfolioSelectedTab.title}`, t),
        projectTypeFilterChange.common.projectTypeFilters,
      );
      setTotalProjects(emptyProjects(indicatorsToProcess.totalProjects));
    } catch (err) {
      console.error(err, 'Error fetching data from indicators');
    } finally {
      dispatch(setLoading(false));
      setIsLoading(false);
    }
  };

  const startProcessIndicators = (inds, titleFromTab, projectTypeFilter: any = [ProjectProductTypes.Loan]) => {
    const result = processIndicators(inds, {
      titleFromTab,
      projectTypeFilter,
    });

    const elementSummary: any = result.find(elem => elem.id === 15);
    const indexSummary: number = result.indexOf(elementSummary);
    const sendEndSummary = arrayMove(result, indexSummary, result.length);

    dispatch(addIndicators(sendEndSummary));
    dispatch(setCurrentIndicator(sendEndSummary?.find(data => data.indicatorKey === 'CALENDAR_EVENTS')));
    setIsLoading(false);
  };

  // const tabId0OrCreatingEditing = (menuTabs, creatingOrEditing) =>
  //   menuTabs.portfolioSelectedTab.tabId === 0 || creatingOrEditing;

  useEffect(() => {
    if (isLoading) getFilteredSimpleIndicators(dispatch, currentIndicator.id, projectTypeFilterChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndicator.id, dispatch, filterIndicators.common, isLoading]);

  useEffect(() => {
    setEventOfMonthState(events);
    onFilterAndSearchChangeHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events, filterIndicators.common]);

  useEffect(() => {
    onFilterAndSearchChangeHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, filterIndicators.common]);

  useEffect(() => {
    onFilterAndSearchChangeHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTermState, filterIndicators.common]);

  useEffect(() => {
    if (
      filterIndicators.common.coReponsibleDivisions.length > 0 ||
      filterIndicators.common.countryId.length > 0 ||
      filterIndicators.common.divisionId.length > 0 ||
      filterIndicators.common.interestIssues.length > 0 ||
      filterIndicators.common.participantDivisions.length > 0 ||
      filterIndicators.common.regionId.length > 0 ||
      filterIndicators.common.sectors.length > 0 ||
      filterIndicators.common.teamLeaders.length > 0
    )
      handleCommonFilterChange();
    setFlag(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  useEffect(() => {
    if (
      !menuTabs.firstLoad &&
      // tabId0OrCreatingEditing(menuTabs, creatingOrEditing) &&
      filterIndicators.common.coReponsibleDivisions.length === 0 &&
      filterIndicators.common.countryId.length === 0 &&
      filterIndicators.common.divisionId.length === 0 &&
      filterIndicators.common.interestIssues.length === 0 &&
      filterIndicators.common.participantDivisions.length === 0 &&
      filterIndicators.common.regionId.length === 0 &&
      filterIndicators.common.sectors.length === 0 &&
      filterIndicators.common.teamLeaders.length === 0
    ) {
      handleCommonFilterChange();
      setFlag(false);

      if (creatingOrEditing) {
        dispatch(updateCreatingOrEditing(false));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  const onChangeHandler = (event: any) => {
    setSearchTermState(event.target.value.toLowerCase());
  };
  const onFilterAndSearchChangeHandler = () => {
    setEventOfMonthState(filterAndSearchEvents(events, searchTermState, filters));
  };

  useEffect(() => {
    return () => {
      dispatch(setCalendarEvents([]));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="calendar-detail-container">
        <div className="left-container">
          <Calendar
            localizer={localizer}
            startAccessor={'start'}
            endAccessor={'end'}
            events={parseEventsForCalendar(eventOfMonthState)}
            defaultView="month"
            formats={{
              weekdayFormat: date => localizer.format(date, 'ddd').substr(0, 3),
            }}
            components={{ toolbar: CalendarDetailToolbar, event: CustomEvent }}
            culture={'en'}
            defaultDate={new Date()}
          />
        </div>

        <div className="right-container">
          <div className="search-input">
            <SearchRender placeholder="search_for_an_event_or_project" onChangeHandler={onChangeHandler} />
          </div>
          <div className="title">{t('to_view')}:</div>
          <CalendarFilters
            disbursements={filters.disbursements}
            acquisitions={filters.acquisitions}
            activities={filters.activities}
            accordancesMonitor={filters.accordancesMonitor}
            accordancesRevision={filters.accordancesRevision}
            supervisoryAction={filters.supervisoryAction}
            secretarialEvents={filters.secretarialEvents}
            lifecycle={filters.lifecycle}
            missions={filters.missions}
            interGroup={filters.interGroup}
            linkOutlook={user.syncCalendar}
            isIndicatorCalendar={true}
          />
        </div>
      </div>
    </>
  );
};

const getFilteredSimpleIndicators = async (d, currentIndicatorId, projectTypeFilterChange?) => {
  return await d(getProjectsCalendarIndicator(currentIndicatorId, undefined, projectTypeFilterChange));
};

const filterAndSearchEvents = (events, searchTermState, filters) => {
  return events.filter(ev => {
    return (
      ((ev.title && ev.title.toLowerCase().search(searchTermState) !== -1) ||
        ev.projectCode.toLowerCase().search(searchTermState) !== -1) &&
      filterEvents(ev, filters)
    );
  });
};

const filterEvents = (ev, filters) => {
  return activityFilters(ev, filters) || accordanceFilters(ev, filters);
};

const activityFilters = (ev, filters) =>
  (parseInt(ev.eventType) === EventType.Disbursement && filters.disbursements) ||
  (parseInt(ev.eventType) === EventType.Acquisition && filters.acquisitions) ||
  (parseInt(ev.eventType) === EventType.Activity && filters.activities) ||
  (parseInt(ev.eventType) === EventType.Mission && filters.missions) ||
  (parseInt(ev.eventType) === EventType.ExternalEvent && filters.secretarialEvents) ||
  (parseInt(ev.eventType) === EventType.Lifecycle && filters.lifecycle) ||
  (parseInt(ev.eventType) === EventType.SupervisoryAction && filters.supervisoryAction);

const accordanceFilters = (ev, filters) =>
  (parseInt(ev.eventType) === EventType.MonitoringAccordance && filters.accordancesMonitor) ||
  (parseInt(ev.eventType) === EventType.RevisionAccordance && filters.accordancesRevision) ||
  (parseInt(ev.eventType) === EventType.InterGroup && filters.interGroup);
